/**
 * Shared accessors for the ephemeral pre-encounter context (Samhengi) that
 * clinicians type alongside a session. SamhengiPanel writes; the page's
 * summary-generation request and the verification hook read. sessionStorage
 * is the canonical store — never the DB, never localStorage.
 */

export const SAMHENGI_STORAGE_KEY_PREFIX = 'samhengi:context:';

export const samhengiStorageKey = (sessionId: string | null | undefined): string | null =>
  sessionId ? `${SAMHENGI_STORAGE_KEY_PREFIX}${sessionId}` : null;

export const readSamhengiContext = (sessionId: string | null | undefined): string => {
  const key = samhengiStorageKey(sessionId);
  if (!key) return '';
  return sessionStorage.getItem(key) ?? '';
};
